import WelcomePage from "./pages/WelcomePage/WelcomePage";
import ProfilePage from "./pages/ProfilePage/ProfilePage";
import ManageServiceUsersPage from "./pages/ManageServiceUsersPage/ManageServiceUsersPage";
import EditProfilePage from "./pages/EditProfilePage/EditProfilePage";
import EditServiceUserPage from "./pages/EditServiceUserPage/EditServiceUserPage";
import AddandEditProfilePage from "./pages/AddandEditProfilePage/AddandEditProfilePage";
import ManageServiceUsersPageMobile from "./pages/ManageServiceUsersPageMobile/ManageServiceUsersPageMobile";
import ServiceDetailsPage from "./pages/ManageServiceUsersPageMobile/ServiceDetailsPage";
import TrustedContactMobilePage from "./pages/ManageServiceUsersPageMobile/TrustedContactMobilePage";
import ProfileMobilePage from "./pages/ProfileMobilePage/ProfileMobilePage";
import ProfileMobileServiceUsersPage from "./pages/ProfileMobilePage/ProfileMobileServiceUsersPage";
import ScheduleServicePage from "./pages/ScheduleServicePage/ScheduleServicePage";
import TripScheduleServicePage from "./pages/ScheduleServicePage/TripScheduleServicePage";
import ScheduleServiceCalenderPage from "./pages/ScheduleServicePage/ScheduleServiceCalenderPage/ScheduleServiceCalenderPage";
import ModeSelectionPage from "./pages/TransportationPage/ModeSelectionPage";
import LevelOfServicePage from "./pages/TransportationPage/LevelOfServicePage";
import TripSummaryPage from "./pages/TransportationPage/TripSummaryPage";
import BookingSummaryPage from "./pages/TransportationPage/BookingSummaryPage";
import TransportationServiceSetupSummaryPage from "./pages/ProfilePage/TransportationServiceSetupSummaryPage";
import { exact } from "prop-types";
import FavoriteDetailsPage from "./pages/ProfilePage/FavoriteDetailsPage";
import BillingHistoryPage from "./pages/ProfilePage/BillingHistoryPage";
import BillingHistoryMobileTransactionPage from "./pages/ProfileMobilePage/BillingHistoryMobileTransactionPage";
import GroceryDeliveryPage from "./pages/GroceryPage/GroceryDeliveryPage";

const routes = [
  {
    path: "/Welcome",
    exact: true,
    name: "WelcomePage",
    component: WelcomePage,
  },
  {
    path: "/DashBoard",
    exact: true,
    name: "ProfilePage",
    component: ProfilePage,
  },
  {
    path: "/DashBoardMobile/ProfileMobilePage/:type",
    exact: true,
    name: "ProfileMobilePage",
    component: ProfileMobilePage,
  },
  {
    path: "/DashBoardMobile/ProfileMobileServiceUsersPage",
    exact: true,
    name: "ProfileMobileServiceUsersPage",
    component: ProfileMobileServiceUsersPage,
  },
  {
    path: "/DashBoard/ManageServiceUsers",
    exact: true,
    name: "ManageServiceUsersPage",
    component: ManageServiceUsersPage,
  },
  {
    path: "/DashBoard/TrustedContactMobilePage/:id/:username",
    exact: true,
    name: "TrustedContactMobilePage",
    component: TrustedContactMobilePage,
  },
  {
    path: "/DashBoard/ManageServiceUsers/:id",
    exact: true,
    name: "ManageServiceUsersPage",
    component: ManageServiceUsersPage,
  },
  {
    path: "/DashBoard/ManageServiceUsersMobile/:id/:parentId/:type",
    exact: true,
    name: "ManageServiceUsersPageMobile",
    component: ManageServiceUsersPageMobile,
  },
  {
    path:
      "/DashBoard/ServiceDetailsPage/:serviceDetails/:parentPersonId/:personId",
    exact: true,
    name: "ServiceDetailsPage",
    component: ServiceDetailsPage,
  },
  {
    path: "/DashBoard/EditProfile/:personId",
    exact: true,
    name: "EditProfilePage",
    component: EditProfilePage,
  },
  {
    path: "/DashBoard/AddServiceUser",
    exact: true,
    name: "AddandEditProfilePage",
    component: AddandEditProfilePage,
  },
  {
    path: "/DashBoard/ScheduleService",
    exact: true,
    name: "ScheduleServicePage",
    component: ScheduleServicePage,
  },
  {
    path: "/DashBoard/ScheduleService/TripSchedule/:careTakerId/:serviceUserId",
    exact: true,
    name: "TripScheduleServicePage",
    component: TripScheduleServicePage,
  },
  {
    path:
      "/DashBoard/ScheduleService/ScheduleServiceCalender/:careGiverId/:careTakerId",
    exact: true,
    name: "ScheduleServiceCalebderPage",
    component: ScheduleServiceCalenderPage,
  },
  {
    path: "/DashBoard/AddServiceUser/Welcome",
    exact: true,
    name: "WelcomePage",
    component: WelcomePage,
  },
  {
    path: "/DashBoard/EditServiceProfile/:personId",
    exact: true,
    name: "EditProfilePage",
    component: EditServiceUserPage,
  },
  {
    path: "/DashBoard/Transportation/ModeSelection/:serviceUserId",
    exact: true,
    name: "ModeSelectionPage",
    component: ModeSelectionPage,
  },
  {
    path: "/DashBoard/Transportation/LevelOfService/:serviceUserId/:ride",
    exact: true,
    name: "LevelOfServicePage",
    component: LevelOfServicePage,
  },
  {
    path:
      "/DashBoard/Transportation/TripSummary/:serviceUserId/:ride/:levelOfService",
    exact: true,
    name: "TripSummary",
    component: TripSummaryPage,
  },
  {
    path: "/DashBoard/Transportation/BookingSummary/:bookingId",
    exact: true,
    name: "BookingSummaryPage",
    component: BookingSummaryPage,
  },
  {
    path:
      "/DashBoard/TransportationServiceSetupSummary/:personId/:requestAssignmentId/:bookingId/:tripStatusId/:tripDate",
    exact: true,
    name: "TransportationServiceSetupSummaryPage",
    component: TransportationServiceSetupSummaryPage,
  },
  {
    path:
      "/DashBoard/FavoriteDetails/:personId/:requestAssignmentId/:bookingId/:favoriteId/:tripDate",
    exact: true,
    name: "FavoriteDetailsPage",
    component: FavoriteDetailsPage,
  },
  {
    path: "/DashBoard/BillingHistory",
    exact: true,
    name: "BillingHistoryPage",
    component: BillingHistoryPage,
  },
  {
    path: "/DashBoard/BillingHistory/:paymentTransactionId",
    exact: true,
    name: "BillingHistoryTransactionPage",
    component: BillingHistoryMobileTransactionPage,
  },
  {
    path: "/DashBoard/GroceryDelivery/:personId",
    exact: true,
    name: "GroceryDeliveryPage",
    component: GroceryDeliveryPage,
  },
];

export default routes;
